module.exports = import("@fortawesome/pro-solid-svg-icons/faUserCrown");;